import { Layout } from 'components/Layout/Layout';
import CMSPage from 'components/PageWrapper/PageWrapper';
import withApollo from 'lib/apollo';
import * as React from 'react';
import { PublicCMSLayout } from '../components/Layout/PublicCMSLayout';

function PrivacyPage() {
  return (
    <Layout classNames={['h-background--navy-200']} title="Privacy Policy">
      <PublicCMSLayout>
        <CMSPage title="Privacy Policy" pageUrl="privacy" />
      </PublicCMSLayout>
    </Layout>
  );
}

export default withApollo(PrivacyPage, { useTemporaryToken: true });
